module.exports = __webpack_public_path__ + "static/7-7abdfddb4890a2eedc6092738012d1fa.jpg";